export default "__VITE_ASSET__EEXG3Y6F__"